import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import { AssessmentReportPdfData } from "../../../../../services/api/types/reports/reports";
import dayjs from "dayjs";

interface AssesmentPdfReportTableProps {
  data: AssessmentReportPdfData | null;
}

export const AssesmentPdfReportTable: React.FC<
  AssesmentPdfReportTableProps
> = ({ data }) => {
  const borderColor = "#EAECF0";
  const headerBg = "#F9FAFB";

  if (!data) {
    return (
      <Paper
        elevation={0}
        sx={{
          border: `1px solid ${borderColor}`,
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0px 1px 3px 0px #1018281A",
          p: 3,
          height: 300,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography color="#475467" fontSize={14} align="center">
          No data available.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        border: `1px solid ${borderColor}`,
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0px 1px 3px 0px #1018281A",
        p: 0,
      }}
    >
      <TableContainer>
        <Table>
          <TableBody>
            <TableRow
              sx={{
                "& th": {
                  fontSize: 14,
                  color: "#475467",
                  fontWeight: 500,
                  borderBottom: `1px solid ${borderColor}`,
                  backgroundColor: headerBg,
                },
              }}
            >
              <TableCell component="th" sx={{ width: 160 }}>
                Acknowledged
              </TableCell>
              <TableCell component="th" sx={{ width: 220 }}>
                Submitted at
              </TableCell>
              <TableCell component="th">Comment</TableCell>
            </TableRow>
            <TableRow
              sx={{
                "& td": {
                  fontSize: 12,
                  color: "#101828",
                  borderBottom: `1px solid ${borderColor}`,
                  py: 1.25,
                },
              }}
            >
              <TableCell>
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.75,
                    px: 1.25,
                    py: 0.4,
                    borderRadius: "16px",
                    backgroundColor:
                      data.ackResponse !== null
                        ? data.ackResponse === true
                          ? "#0676471A"
                          : "#B423181A"
                        : "none",
                    border: `1px solid ${data.ackResponse !== null ? (data.ackResponse === true ? "#ABEFC6" : "#FECDCA") : "none"}`,
                    whiteSpace: "nowrap",
                  }}
                >
                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color={
                      data.ackResponse !== null
                        ? data.ackResponse === true
                          ? "#067647"
                          : "#B42318"
                        : "#101828"
                    }
                    lineHeight={1}
                  >
                    {data.ackResponse !== null
                      ? data.ackResponse === true
                        ? "Yes"
                        : "No"
                      : "-"}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {data.submittedAt
                  ? dayjs(data.submittedAt).format("DD-MMM-YYYY HH:mm")
                  : "-"}
              </TableCell>
              <TableCell>
                {data.comment === "" || data.comment === null
                  ? "-"
                  : data.comment}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
